import config from '../config'
import history from '../common/history'
import { version } from '../../package.json'

const clientVersion = `customer-portal ${version}`

const onApiError = e => {
  throw e
}

const onApiSuccess = res => res

const BEARER_TOKEN_NAME = 'bearer_token'
const EMAIL_TOKEN_NAME = 'email_token'
const tokenStorage = (tokenName) => (function () {
  // Note: use local storage to store token whenever possible
  // if not found, downgrade to local variable, which will require users
  // to sign in after refreshing pages
  if (typeof localStorage !== 'undefined') {
    return {
      get: () => {
        return localStorage.getItem(tokenName)
      },
      set: (token) => {
        return localStorage.setItem(tokenName, token)
      },
      remove: () => {
        return localStorage.removeItem(tokenName)
      }
    }
  }

  let token = null

  return {
    get: () => {
      return token
    },
    set: (tk) => {
      token = tk
    },
    remove: () => {
      token = null
    }
  }
})()

const bearerTokenStorage = tokenStorage(BEARER_TOKEN_NAME)
const emailTokenStorage = tokenStorage(EMAIL_TOKEN_NAME)

const invokeApi = ({
  path,
  method = 'GET',
  headers = {},
  authorization = false,
  body
}) => {
  const apiUrl = config.API_URL + path
  if (authorization) {
    const token = bearerTokenStorage.get()
    if (token && token.length && token !== 'null') {
      headers.Authorization = `Bearer ${token}`
      headers['synkedup-version'] = clientVersion
    }
  }
  body = body && JSON.stringify(body)
  return fetch(apiUrl, {
    method,
    body,
    headers
  }).then(results => {
    if (results.status === 401 || results.status === 403) {
      logout()
      throw new Error('Unauthorized')
    }
    if (results.status !== 200) {
      return results.json().then(data => {
        return Promise.reject(data)
      })
    }

    return results.json().then(json => Promise.resolve(json)).catch(() => Promise.resolve(null))
  })
}

export const login = (username, password) => { }

export const logout = () => {
  bearerTokenStorage.remove()
  emailTokenStorage.remove()
  history.push('/login')
}

export const getUserInfo = () => { }

const processToken = (data, emailToken) => {
  if (data.access_token && data.access_token.length) {
    bearerTokenStorage.set(data.access_token)
    emailTokenStorage.set(emailToken)
  }
  return {
    hasPassword: data.hasPassword,
    expired: data.expired,
    customerName: data.customerName,
    canResend: data.canResend
  }
}

const defaultHeaders = {
  'synkedup-version': clientVersion,
  'Content-Type': 'application/json'
}

export const authorizeToken = (userId, emailToken) =>
  invokeApi({
    method: 'GET',
    path: `/customer-portal/api/authorize?userId=${userId}&token=${emailToken}`,
    headers: { ...defaultHeaders }
  }).then((res) => {
    return processToken(res, emailToken)
  }).then(onApiSuccess, onApiError)

export const refreshToken = (refreshToken) =>
  invokeApi({
    method: 'POST',
    path: '/customer-portal/api/token',
    headers: { ...defaultHeaders, 'Content-Type': 'application/x-www-form-urlencoded' },
    body: `grant_type=refresh_token&refresh_token=${refreshToken}`
  }).then((res) => {
    return processToken(res)
  }).then(onApiSuccess, onApiError)

export const authorizeResend = (userId, url, token) =>
  invokeApi({
    method: 'POST',
    path: `/customer-portal/api/authorize/resend?userId=${userId}&redirectUrl=${url}&token=${token}`,
    headers: { ...defaultHeaders }
  }).then(onApiSuccess, onApiError)

export const getProposal = (id, preview) =>
  invokeApi({
    method: 'GET',
    path: preview
      ? `/customer-portal/api/proposals/preview/${id}`
      : `/customer-portal/api/proposals/${id}`,
    headers: { ...defaultHeaders },
    authorization: true
  }).then(onApiSuccess, onApiError)

export const approveProposal = (data) =>
  invokeApi({
    method: 'POST',
    path: '/customer-portal/api/proposals',
    headers: { ...defaultHeaders },
    body: data,
    authorization: true
  }).then(onApiSuccess, onApiError)

export const getViewPdfLink = (isPreview) => {
  if (isPreview) {
    return `${config.API_URL}/api/web/proposals/pdf/preview/${emailTokenStorage.get()}`
  }
  return `${config.API_URL}/api/web/proposals/pdf/${emailTokenStorage.get()}`
}
